import React, { useState } from 'react';
import TeacherDeckSection from '../models/TeacherDeckSection';

const DeckManager = ({ classId, classData, fetchClassData }) => {
  const [newDeckTitle, setNewDeckTitle] = useState('');

  const handleCreateDeck = async (e) => {
    e.preventDefault();
    if (!newDeckTitle.trim()) return;

    try {
      await fetch('https://amora-backend.onrender.com/api/classes/' + classId + '/decks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ title: newDeckTitle }),
      });

      setNewDeckTitle('');
      await fetchClassData(); // refresh decks
    } catch (err) {
      console.error('Failed to create deck:', err);
    }
  };

  return (
    <div>
      {/* Create Deck */}
      <div className="bg-gray-800 p-6 rounded-xl shadow mb-8 max-w-md mx-auto">
        <h2 className="text-xl font-semibold text-purple-300 mb-4 text-center">📂 Create a New Deck</h2>
        <form onSubmit={handleCreateDeck} className="flex gap-2">
          <input
            type="text"
            value={newDeckTitle}
            onChange={(e) => setNewDeckTitle(e.target.value)}
            placeholder="Deck Title"
            className="flex-1 px-4 py-2 rounded-lg border border-gray-600 bg-gray-700 text-white focus:outline-none"
            required
          />
          <button
            type="submit"
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-semibold"
          >
            ➕
          </button>
        </form>
      </div>

      {/* Existing Decks */}
      <TeacherDeckSection
        classId={classId}
        decks={classData.decks}
        onDeckUpdate={fetchClassData}
      />
    </div>
  );
};

export default DeckManager;
